import React from 'react';

import { type BaseCurrencyType } from '@pkg/types';

import { CurrencyIcon } from '../../CurrencyIcon';
import { currencyName } from '../CurrencySelector.data';

import { IconWrapper, Name, Option, StyledItem, Symbol } from './Menu.style';

export interface ItemProps {
    currency: BaseCurrencyType;
    ariaLabel?: string;
    disabled?: boolean;
    pressed?: boolean;
    onSelect: (currency: BaseCurrencyType) => void;
}

const DEFAULT_ARIA_LABEL = 'Select this currency as the new default';

export function Item({
    currency,
    ariaLabel = DEFAULT_ARIA_LABEL,
    disabled = false,
    pressed = false,
    onSelect,
}: ItemProps) {
    return (
        <StyledItem>
            <Option
                aria-label={ariaLabel}
                aria-pressed={pressed ? true : undefined}
                disabled={disabled ? true : undefined}
                onClick={() => onSelect(currency)}
            >
                <Symbol>
                    <IconWrapper>
                        <CurrencyIcon currency={currency} theme="dark" />
                    </IconWrapper>
                </Symbol>

                <Name>{currencyName[currency]}</Name>
            </Option>
        </StyledItem>
    );
}
